import { ILayoutBreakpointColumns } from '../../types/layout';

export const getBreakpointColumnsClass = (breakpoints?: ILayoutBreakpointColumns | boolean): string => {
    if (typeof breakpoints === 'undefined' || breakpoints instanceof Object) {
        const classes: string[] = ['col-12'];
        if (breakpoints && typeof breakpoints === 'object') {
            const keys = Object.keys(breakpoints) as (keyof ILayoutBreakpointColumns)[];
            keys.forEach((key) => {
                classes.push(`col-${key}-${breakpoints[key]}`);
            });
        }
        return classes.join(' ');
    }
    return '';
};
